import { render, staticRenderFns } from "./DisputeFilter.vue?vue&type=template&id=677f358a"
import script from "./DisputeFilter.vue?vue&type=script&lang=js"
export * from "./DisputeFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports